module.exports = __webpack_public_path__ + "static/img/img2.0073fb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202212/img2.png
// module id = v+AJ
// module chunks = 0